import { COOKIE_NAME } from "@app/components/config";
import { setCookie } from "@app/utils/cookie";
import type { RootState } from "@lib/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface loginState {
  isLoggedIn: boolean;
  role: string;
  userDetails: any;
  profilePicture: any;
  verificationStatus: any;
}

const initialState: loginState = {
  isLoggedIn: false,
  role: "",
  profilePicture: "",
  userDetails: {
    userId: "",
    fullName: "",
    sourceId: "",
    email: "",
    mobile: "",
    nationality: "",
    status: "",
    source: "",
    providerUserId: "",
    isEmailVerified: false,
    isMobileVerified: false,
  },
  verificationStatus: "",
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setRole: (state, action: PayloadAction<string>) => {
      setCookie(COOKIE_NAME.role, JSON.stringify(action.payload));
      state.role = action.payload;
    },
    setLoggedIn: (state, action: PayloadAction<boolean>) => {
      setCookie(COOKIE_NAME.isLoggedIn, JSON.stringify(action.payload));
      state.isLoggedIn = action.payload;
    },
    setProfilePicture: (state, action: PayloadAction<string>) => {
      setCookie(COOKIE_NAME.profilePicture, JSON.stringify(action.payload));
      state.profilePicture = action.payload;
    },
    setUserDetails: (state, action: PayloadAction<any>) => {
      setCookie(COOKIE_NAME.userDetails, JSON.stringify(action.payload));
      state.userDetails = { ...action.payload };
    },
    setUserVerificationStatus: (state, action: PayloadAction<any>) => {
      state.verificationStatus = action.payload;
    },
    removeUserDetails: (state) => {
      state.userDetails = {
        userId: "",
        fullName: "",
        sourceId: "",
        email: "",
        mobile: "",
        nationality: "",
        status: "",
        source: "",
        providerUserId: "",
        isEmailVerified: false,
        isMobileVerified: false,
      };
    },
  },
});

export const {
  setRole,
  setLoggedIn,
  setUserDetails,
  setProfilePicture,
  setUserVerificationStatus,
  removeUserDetails,
} = loginSlice.actions;

export const getRole = (state: RootState) => state.login.role;

export const getIsLoggedIn = (state: RootState) => state.login.isLoggedIn;

export const getProfilePicture = (state: RootState) =>
  state.login.profilePicture;

export const getUserDetail = (state: RootState) => state.login;

export const getUserVerificationStatus = (state: RootState) =>
  state.login.verificationStatus;

export default loginSlice.reducer;
